import type { Identifiers } from '@atlaskit/feature-gate-js-client';
import React, { ReactNode, useMemo } from 'react';
import { useAppSelector } from '../stores/redux.store';
import { getFfsId } from '../utilities/feature-flags';
import { FeatureGatesInit } from './FeatureGatesInit';

type FeatureGateProviderProps = {
  children: ReactNode;
};

export const FeatureGateProvider = ({ children }: FeatureGateProviderProps) => {
  const tenantId = useAppSelector(state => state.context?.tenantCloudId);
  const atlassianAccountId = useAppSelector(state => state.context?.userId);
  const ffsId = getFfsId();

  const identifiers: Identifiers = useMemo(
    () => ({
      tenantId,
      atlassianAccountId,
      randomizationId: ffsId,
    }),
    [tenantId, atlassianAccountId, ffsId]
  );

  return (
    <FeatureGatesInit identifiers={identifiers} initializingComponent={null}>
      {children}
    </FeatureGatesInit>
  );
};
